export const InvoiceConstants = {
    AccountCodesForRepFilters  : ["643","650"] 
}